import GATSBY_COMPILED_MDX from "/home/circleci/application/src/markdown-pages/blog/2023/2023-05-31/index.fi-fi.mdx";
import {graphql} from "gatsby";
import React, {useContext} from "react";
import {MDXProvider} from "@mdx-js/react";
import {toDateShortFormat} from "utils/date";
import {LocaleContext} from "contexts";
import useTranslations from "hooks/useTranslations";
import get from "lodash.get";
import ContentPageContainer from "components/molecules/common/ContentPageContainer";
import SubscribeForm from "components/SubscribeForm";
import Box from "components/atoms/BlogBox";
import BlogLink from "components/atoms/BlogLink";
import Report2023DownloadForm from "components/organisms/common/Report2023DownloadForm";
import Report2024DownloadForm from "components/organisms/common/Report2024DownloadForm";
import "styles/index.global.css";
import * as styles from "./blogTemplate.module.css";
const shortcodes = {
  Box,
  Report2023DownloadForm,
  Report2024DownloadForm,
  a: BlogLink
};
function Template({data, children}) {
  const {blogTimeToRead, blogMinute, blogMinutes} = useTranslations();
  const {locale} = useContext(LocaleContext);
  const {frontmatter, fields: {timeToRead}} = get(data, "mdx");
  const dateObj = new Date(frontmatter.date);
  const {title, spoiler, showNewsletterCTA, image} = frontmatter;
  return React.createElement("main", null, React.createElement(ContentPageContainer, {
    title: title,
    description: spoiler,
    image: image && image.publicURL
  }, React.createElement(MDXProvider, {
    components: shortcodes
  }, React.createElement("div", {
    className: styles.content
  }, React.createElement("p", null, React.createElement("time", {
    dateTime: `${dateObj}`
  }, toDateShortFormat(dateObj, locale)), " ", "| ", React.createElement("span", {
    className: "mr-1"
  }, blogTimeToRead, ":"), React.createElement("span", {
    className: "font-bold"
  }, Math.ceil(timeToRead.minutes), " ", timeToRead.minutes >= 1 ? blogMinutes : blogMinute)), children)), showNewsletterCTA ? React.createElement(SubscribeForm) : null));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Template, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query ($locale: String!, $title: String!) {
    mdx(
      frontmatter: { title: { eq: $title } }
      fields: { locale: { eq: $locale } }
    ) {
      fields {
        timeToRead {
          minutes
        }
      }
      frontmatter {
        title
        date
        spoiler
        showNewsletterCTA
        image {
          publicURL
        }
      }
    }
  }
`;
